import Tab from 'bootstrap/js/dist/tab';
import Modal from 'bootstrap/js/dist/modal';
import Collapse from 'bootstrap/js/dist/collapse';

const body = document.querySelector('body');

// When the DOM is loaded, remove "preload"

document.addEventListener('DOMContentLoaded', function() {
  body.classList.remove('preload');
});


// Mobile menu

const navToggle = document.querySelector('.mobile-nav-toggle');
const mobileNav = document.querySelector('.mobile-nav');

function scrollbarWidth() {
  // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
  const documentWidth = document.documentElement.clientWidth;
  return Math.abs(window.innerWidth - documentWidth);
}


if (navToggle && mobileNav) {
  let mobileNavOpen = false;

  navToggle.addEventListener('click', toggleNav);

  function toggleNav() {
    mobileNavOpen = !mobileNavOpen;
    const isBodyOverflowing = scrollbarWidth() > 0;

    if (mobileNavOpen && isBodyOverflowing) {
      body.style.overflowY = 'scroll';
    } else {
      body.style.overflowY = '';
    }

    navToggle.setAttribute('aria-expanded', mobileNavOpen);
    navToggle.classList.toggle('is-open');
    mobileNav.classList.toggle('is-open');
    body.classList.toggle('mobile-nav-open');
    window.scrollTo(0, 0);
  }
}


// FAQ

let collapseList = document.querySelectorAll('.faq-answer.collapse');

collapseList.forEach(function (collapseNode) {
  const collapse = new Collapse(collapseNode, {
    toggle: false,
    parent: collapseNode.closest('ul.faq')
  });

  collapseNode.addEventListener('shown.bs.collapse', function () {
    this.closest('li').scrollIntoView({behavior: "smooth", block: "nearest"});
  });

  const closeBtn = collapseNode.querySelector('.btn-close');

  closeBtn.addEventListener('click', () => collapse.hide());
});



// Newsletter Modal

function setCookie(name) {
  document.cookie = `${name}=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; SameSite=Strict; path=/;`;
};

function cookieExists(name) {
  if (name) {
    return document.cookie.split('; ').find(row => row.startsWith(name));
  } else {
    return false;
  }
}

const newsletterModalElem = document.getElementById('newsletter-modal');

if (newsletterModalElem) {
  const newsletterModal = new Modal(newsletterModalElem);
  let cookieName = 'newsletter-signup';

  if (!cookieExists(cookieName)) {
    newsletterModalElem.addEventListener('hidden.bs.modal', () => setCookie(cookieName));
    newsletterModal.show();
  }
}


// Location Tabs

const locationSelect = document.getElementById('location-select');

if (locationSelect) {
  locationSelect.addEventListener('change', () => {
    const target = locationSelect.value + '-tab';
    const triggerEl = document.getElementById(target)
    const tab = Tab.getOrCreateInstance(triggerEl) // Returns a Bootstrap tab instance
    tab.show();
  })
}

var locationTabs = document.querySelectorAll('.location-nav-tabs button[data-bs-toggle="tab"]');

locationTabs.forEach((tab) => {
  tab.addEventListener('shown.bs.tab', function (event) {
    const target = event.target;
    const newValue = target.getAttribute('data-bs-target').replace('#', '');
    locationSelect.value = newValue;
  })
})


// Play Pronunciation Audio

const pronAudio = document.querySelector('#pronunciation-audio');
const playAudioButtons = document.querySelectorAll('.js-play-pronunciation');

if (pronAudio) {
  playAudioButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      pronAudio.currentTime = 0;
      pronAudio.play()
    });
  })
}
